import { InjectedFormProps, reduxForm } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React from 'react';
import { required, Validators } from 'src/components/redux-form/utils/validators';
import classNames from 'classnames';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import styles from './components/assets/substitution-form.module.scss';
import { toast } from 'react-toastify';
import { FieldDropdown } from 'src/components/redux-form/fields/FieldDropdown';
import { FieldDate } from 'src/components/redux-form/fields/FieldDate';

import { Paginated } from 'src/services/api-handlers/pagination';
import InvoicePaymentGrid from './components/InvoicePaymentGrid';
import { IServiceType } from '../../../../../types/service-types';
import { IInvoice } from '../../../../../types/invoice';
import { FieldArray } from 'redux-form';

import RenderDetailFieldArray from './components/RenderDetailFieldArray';
import { QueryParams } from '../../../../../types/grid';
import { numberWithCommas } from '../../../../../helpers/format';

export interface PaymentFormData {
    id: string | number;
    paymentInvoices: any;
    paymentCredits: any;
    amount: number;
    caseType: any;
    eftInfo: string;
    paymentDate: string;
}

interface PaymentFormProps {
    students: SelectObject[];
    vendors: SelectObject[];
    providers: SelectObject[];
    districts: SelectObject[];
    invoices: Paginated<IInvoice>;
    getData: (params: QueryParams) => void;
    stateData: any;
    paymentCredits?: any;
    remainAmount: number;
    amountValue: number;
    caseNumbers: { [key: string]: string | null }[];
    totalAmount: number;
    caseTypeHistory?: any;
    setStateData: (data: any) => void;
    serviceTypes: Paginated<IServiceType>;
    handleSub: (data: (e: any) => void, e: any) => void;
}

type InjectedProps = InjectedFormProps<PaymentFormData, PaymentFormProps>;

const validators: Validators<PaymentFormData> = {
    paymentDate: [required({ message: 'Payment Date is required.' })],
    eftInfo: [required({ message: 'Check/EFT Info is required.' })],
    amount: [required({ message: 'Amount, $ is required.' })],
};

const PaymentForm: React.FunctionComponent<InjectedProps & PaymentFormProps> = ({
    handleSubmit,
    error,
    students,
    vendors,
    districts,
    invoices,
    providers,
    serviceTypes,
    setStateData,
    stateData,
    caseTypeHistory,
    getData,
    remainAmount,
    totalAmount,
    amountValue,
    caseNumbers,
    initialValues,
}: InjectedProps & PaymentFormProps) => {
    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form)}>
            <FormError error={error} />

            <div className="d-flex flex-row">
                <div className="w-25 mr-5">
                    <FieldDate
                        name="paymentDate"
                        type="text"
                        disabled={true}
                        validate={validators.paymentDate}
                        date={true}
                        wrapperConfig={{
                            label: 'Payment Date: *',
                        }}
                    />
                </div>
                <div className="w-25 mr-5">
                    <FieldInput
                        name="eftInfo"
                        disabled={true}
                        validate={validators.eftInfo}
                        type="text"
                        wrapperConfig={{
                            label: 'Check/EFT Info: *',
                        }}
                    />
                </div>
                <div className="w-25 mr-5">
                    <FieldInput
                        name="amount"
                        disabled={true}
                        validate={validators.amount}
                        type="number"
                        wrapperConfig={{
                            label: 'Amount, $: *',
                        }}
                    />
                </div>
                <div className="w-25 mr-5">
                    <FieldDropdown
                        name={`caseType`}
                        data={[caseTypeHistory]}
                        disabled={true}
                        textField={'label'}
                        withSearchInput={true}
                        valueField={'value'}
                        wrapperConfig={{
                            label: 'Case Type:',
                        }}
                    />
                </div>
            </div>
            <div className={'list-invoices'}>
                <div className={`${classNames('pageHeadingTitle')}`}>Apply to Cases & Invoices:</div>
                <InvoicePaymentGrid
                    students={students}
                    vendors={vendors}
                    invoices={invoices}
                    providers={providers}
                    detail={true}
                    getData={getData}
                    changeValue={(field, value) => false}
                    districts={districts}
                    serviceTypes={serviceTypes}
                    caseTypeHistory={caseTypeHistory}
                    stateData={stateData}
                    amountValue={amountValue}
                    paymentId={initialValues?.id}
                    caseType={initialValues?.caseType}
                    setStateData={setStateData}
                />
            </div>
            <div className={'credits'}>
                <div className={`${classNames('pageHeadingTitle')}`}>
                    Sum of the entered values: ${numberWithCommas(totalAmount)}. Remaining amount:{' '}
                    <span> ${numberWithCommas(remainAmount)}</span>
                </div>
                <div className={`${classNames('pageHeadingTitle')}`}>Apply the remaining amount to a credit:</div>
                <FieldArray
                    disabled={true}
                    name="paymentCredits"
                    caseNumbers={caseNumbers}
                    component={RenderDetailFieldArray}
                />
            </div>
        </form>
    );
};

export default reduxForm<PaymentFormData, PaymentFormProps>({
    form: 'payment-form',
    enableReinitialize: true,

    onSubmitSuccess() {
        toast.success('add substitution success.');
    },

    onSubmitFail(errors: { _error: string }) {
        if (errors._error) {
            toast.error(errors._error);
        }
    },
})(PaymentForm);
